/**
 * Callback function used to tell M2 that the chat is ready. One the chat is ready for users to interact with, it will hide navigation so the focus can go to the iframe UI. It checks the uuid sent by the childframe with the stored chatbotId and also checks that the event type is 'chatReady' before disabling navigation and sending a message to the chatbot to set focus.
 *
 * @param {Object} ev - event from chatbot containing the close event type and uuid.
 * @param {Object} ev.data - data being passed by the chatbot to the M2 application
 * @param {string} ev.data.type - type of event being sent by the chatbot. Should be 'chatReady'.
 * @param {string} ev.data.uuid - uuid of the chatbot frame.
 */
var chatReadyCallback = function chatReadyCallback(_ref) {
  var _ref$data = _ref.data,
      type = _ref$data.type,
      uuid = _ref$data.uuid;

  if (type === 'chatReady' && uuid && window.WF_CHATBOT.uuid === uuid) {
    window.WF_CHATBOT.disableNavigation();
    window.WFUI_BRIDGE.postMessageToChildren(window.WF_CHATBOT.uuid, {
      type: 'setChatFocus'
    });
  }
};
/**
 * Adds event listener to close the chatbot cild frame.
 */


export var addChatReady = function addChatReady() {
  window.WFUI_BRIDGE.registerEventListener('chatReady', chatReadyCallback, window.WF_CHATBOT.uuid);
};